module.exports = __webpack_public_path__ + "static/media/boxes-alt.bcfcd789.svg";